import { useQuery } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { DealStatusStat, Guid } from '../../models';

export function useDealStatusHistoryQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.StatusHistory(guid),
		() => AxiosUtils.getResponseData<DealStatusStat[]>(api.get(CerebroApiEndpoints.StatusHistory(guid))),
		{ enabled: guid !== undefined }
	);
}
